export default __webpack_public_path__ + "static/media/flag-icon.bd9f1a8d.svg";